import axios from "axios";
import Swal from "sweetalert2";
import { CommonAxiosPost } from "../CommonAxios/CommonAxios";
export const successAlert = () => {
    Swal.fire({
        text: "Submitted Successfully",
        icon: "success",
        backdrop: true,
        willClose: () => {
            window.location.reload();
        }
    })
};
export const successAlertttt = (applicantId, showprintpopup) => {
    Swal.fire({
        title: "Submitted Successfully",
        text: `Your Application Id is ${applicantId}`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: 'Click here to print application',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        focusConfirm: false,
        footer: '',
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: showprintpopup,
    }).then((response) => {
        if (response.isConfirmed) {
            console.log("Confirmed");
        }
    })
};



export const failureAlert = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "error",
    })
};

export const deleteAlert = (index, formikFieldArray) => {
    Swal.fire({
        text: "Do you want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
    }).then((willDelete) => {

        if (willDelete.isConfirmed) {
            formikFieldArray.remove(index);

        }
    })
};
export const deleteAlert2 = (delUrl) => {
    Swal.fire({
        text: "Do you want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
    }).then((willDelete) => {

        if (willDelete.isConfirmed) {
            axios.delete(delUrl).then((res) => {
                if (res.data != null) {
                    if (res.data.ResponseCode === "01") {
                        successAlert();
                    } else {

                        failureAlert(res.data.ResponseDesc);
                    }
                } else {
                    failureAlert(res.data.ResponseDesc);
                }
            })
        }
    })
};
export const saveAlert = (url, data, msg, callback) => {
    Swal.fire({
        title: "Are you sure ?",
        text: msg,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
    }).then((save) => {
        if (save.isConfirmed) {
            CommonAxiosPost(url, data).then((res) => {
                if (res?.data?.scode === '01') {
                    Sweetalert(res.data.sdesc, 'success')
                    callback();
                }
                else if (res.data.scode === '02') {
                    Sweetalert(res.data.sdesc, 'warning')
                }

            })
        }
    })
};
export const InfoAlert = (data) => {
    Swal.fire({
        text: data,
        icon: "info",
    })
};
export const InfoAlert2 = (data, icon) => {
    Swal.fire({
        text: data,
        icon: icon,
        backdrop: true,
        allowOutsideClick: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        didOpen: () => {
            const swalModal = Swal.getPopup();
            if (swalModal) {
                swalModal.setAttribute("tabindex", "0");
                swalModal.focus();
            }
        },
    })
};
export const TokenAlert = () => {
    Swal.fire({
        text: "Your session has expired. Please Login",
        icon: "warning",
        backdrop: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"

    }).then((update) => {

        if (update.isConfirmed) {
            window.location.href = "/";
        }
    })
};


export default async function Sweetalert(text, icon) {

    return Swal.fire({
        text: text, icon: icon,
        confirmButtonColor: '#3085d6', allowEnterKey: true,
        allowEscapeKey: true, allowOutsideClick: true, confirmButtonText: "Ok"
    });
}
export function SweetalertHtml(text, icon) {
    return Swal.fire({
        html: text,
        icon: icon,
        confirmButtonColor: '#3085d6',
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Ok"
    });
}
export const InfoAlertWithBackTabDisabled = (data, icon) => {
    Swal.fire({
        text: data,
        icon: icon,
        backdrop: true,
        allowOutsideClick: false,

        allowEscapeKey: false,
        didOpen: () => {
            const swalModal = Swal.getPopup();
            if (swalModal) {
                swalModal.setAttribute("tabindex", "0");
                swalModal.focus();
            }
        },
    })
};

